<template>
  <div v-if="loading" class="row" style="background-color: #fff;">
    <div class="col-12">
      <!-- <div class="loader">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${$t('reports.detractor.loadingLabel')}...`"
        ></b-spinner>
      </div> -->
      <b-table
        striped
        responsive
        id="table-positive"
        :items="[0, 1, 2, 3]"
        :fields="indicatorsFields"
      >
        <template v-slot:cell(indicator)>
          <div style="min-width: 70px;">
            <idx-skeleton width="180" height="15" radius="10" />
          </div>
        </template>
        <template v-slot:cell(value)>
          <idx-skeleton width="75" height="15" radius="10" />
        </template>
        <template v-slot:cell(score)>
          <idx-skeleton width="45" height="15" radius="10" />
        </template>
        <template v-slot:cell(total)>
          <idx-skeleton width="45" height="15" radius="10" />
        </template>
      </b-table>
    </div>
  </div>
  <div v-else class="row">
    <div class="col-12">
      <div class="reports-wrapper">
        <div
          class="card"
          :style="`width: 100%; height: ${
            dataGraph.layout.h * 38
          }px; overflow-x: hidden;`"
        >
          <label for="select-indicator" style="font-size: 12px;">{{
            $t('reports.sentmentAnalysis.selectTitle')
          }}</label>
          <div style="width: 250px;">
            <b-form-select
              v-model="indicatorSelected"
              id="select-indicator"
              :options="indicatorLabels"
              style="font-size: 12px;"
            ></b-form-select>
          </div>

          <div v-if="indicatorSelected" class="mt-4">
            <b-table
              striped
              responsive
              id="table-positive"
              :items="indicatorsItems"
              :fields="indicatorsFields"
              :busy="loadingIndicators"
              :per-page="10"
              :current-page="currentPage"
              style="font-size: 12px;"
            >
              <template v-slot:table-busy>
                <!-- <div class="text-center text-primary my-2">
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div> -->
                <div class="row mb-2" v-for="i in [0, 1, 2]" :key="i">
                  <b-col>
                    <idx-skeleton height="15" radius="10" />
                  </b-col>
                  <b-col class="text-center">
                    <idx-skeleton height="15" radius="10" />
                  </b-col>
                  <b-col class="text-right">
                    <idx-skeleton height="15" radius="10" class="ml-4" />
                  </b-col>
                  <b-col class="text-right">
                    <idx-skeleton height="15" radius="10" class="ml-4" />
                  </b-col>
                </div>
              </template>
              <template v-slot:cell(progress)="row">
                <div style="min-width: 70px;">
                  <b-progress class="mt-1" :max="row.item.total" show-value>
                    <b-progress-bar
                      :value="row.item.positiveQty"
                      variant="primary"
                    ></b-progress-bar>
                    <b-progress-bar
                      :value="row.item.neutralQty"
                      variant="warning"
                    ></b-progress-bar>
                    <b-progress-bar
                      :value="row.item.negativeQty"
                      variant="danger"
                    ></b-progress-bar>
                  </b-progress>
                </div>
              </template>
            </b-table>

            <div class="mt-4">
              <b-pagination
                v-model="currentPage"
                :total-rows="indicatorsItems.length"
                :per-page="10"
                aria-controls="table-sentment-by-indicators"
                style="font-size: 12px;"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import idxSkeleton from '@/components/molecules/idx-skeleton';
import RadialProgressBar from 'vue-radial-progress';
import Indicators from '../../reports/indicators';
import EventBus from '../../../../../eventBus';
import api from '../../../../../services/api';

export default {
  components: {
    RadialProgressBar,
    Indicators,
    idxSkeleton,
  },

  props: ['dataGraph'],

  data: () => ({
    loading: true,
    fieldsPositive: [
      { key: 'word', label: 'Keywords positivas' },
      {
        key: 'progress',
        label: '',
      },
      {
        key: 'percentage',
        label: 'Score',
      },
      {
        key: 'occurrences',
        label: 'Total',
      },
    ],
    fieldsNeutral: [
      { key: 'word', label: 'Keywords neutras' },
      {
        key: 'progress',
        label: '',
      },
      {
        key: 'percentage',
        label: 'Score',
      },
      {
        key: 'occurrences',
        label: 'Total',
      },
    ],
    fieldsNegative: [
      { key: 'word', label: 'Keywords negativas' },
      {
        key: 'progress',
        label: '',
      },
      {
        key: 'percentage',
        label: 'Score',
      },
      {
        key: 'occurrences',
        label: 'Total',
      },
    ],
    indicatorsFields: [
      { key: 'indicator', label: 'Indicador' },
      { key: 'value', label: 'Descrição', sortable: true },
      {
        key: 'progress',
        label: '',
      },
      {
        key: 'score',
        label: 'Score',
        class: 'text-center numbers-area',
        sortable: true,
      },
      {
        key: 'total',
        label: 'Total',
        class: 'text-center numbers-area',
        sortable: true,
      },
    ],
    indicatorSelected: null,
    indicatorLabels: [],
    indicatorsItems: [],
    currentPage: 1,
    loadingIndicators: false,
  }),

  methods: {
    async getReportsData(data) {
      this.loading = true;

      this.indicatorsItems = [];
      this.indicatorSelected = null;

      await Promise.all([this.getIndicators(data)]);

      this.loading = false;
    },

    async getIndicators(dataGraph) {
      this.indicatorSelected = null;
      this.indicatorLabels = [
        {
          value: null,
          text: this.$t('reports.sentmentAnalysis.selectPlaceholder'),
        },
      ];

      const response = await api.get(
        `indicators/distinct/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: dataGraph.actionId ? dataGraph.actionId._id : null,
            ih1: dataGraph.ih1 && dataGraph.ih1.length > 0 ? dataGraph.ih1.map((item) => item._id): null,
            metric: dataGraph.metric,
            groupId: dataGraph.actionGroupId
              ? dataGraph.actionGroupId._id
              : null,
          },
        },
      );

      response.data.indicators.forEach((indicator) => {
        this.indicatorLabels.push({
          value: indicator.key,
          text: indicator.text,
        });
      });
    },

    async getSentmentAnalysisByIndicators(dataGraph) {
      this.loadingIndicators = true;

      const response = await api.get('/reports/sentment-analysis/indicator', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: dataGraph.actionId ? dataGraph.actionId._id : null,
          ih1: dataGraph.ih1 && dataGraph.ih1.length > 0 ? dataGraph.ih1.map((item) => item._id): null,
          metric: dataGraph.metric,
          groupId: dataGraph.actionGroupId ? dataGraph.actionGroupId._id : null,
          indicator: this.indicatorSelected,
          period: dataGraph.period,
          _id: this.dataGraph._id,
        },
      });

      this.indicatorsItems = response.data;

      this.loadingIndicators = false;
    },

    setColor(score) {
      if (score >= 60) {
        return '#22CD70';
      } else if (score >= 0) {
        return '#F3C102';
      }

      return '#E84C3E';
    },

    changeLabels() {
      this.fieldsPositive = [
        {
          key: 'word',
          label: this.$t(
            'reports.sentmentAnalysis.keywordsTablePositive.keywords',
          ),
        },
        {
          key: 'progress',
          label: '',
        },
        {
          key: 'percentage',
          label: this.$t(
            'reports.sentmentAnalysis.keywordsTablePositive.percentage',
          ),
        },
        {
          key: 'occurrences',
          label: this.$t(
            'reports.sentmentAnalysis.keywordsTablePositive.total',
          ),
        },
      ];

      this.fieldsNeutral = [
        {
          key: 'word',
          label: this.$t(
            'reports.sentmentAnalysis.keywordsTableNeutral.keywords',
          ),
        },
        {
          key: 'progress',
          label: '',
        },
        {
          key: 'percentage',
          label: this.$t(
            'reports.sentmentAnalysis.keywordsTableNeutral.percentage',
          ),
        },
        {
          key: 'occurrences',
          label: this.$t('reports.sentmentAnalysis.keywordsTableNeutral.total'),
        },
      ];

      this.fieldsNegative = [
        {
          key: 'word',
          label: this.$t(
            'reports.sentmentAnalysis.keywordsTableNegative.keywords',
          ),
        },
        {
          key: 'progress',
          label: '',
        },
        {
          key: 'percentage',
          label: this.$t(
            'reports.sentmentAnalysis.keywordsTableNegative.percentage',
          ),
        },
        {
          key: 'occurrences',
          label: this.$t(
            'reports.sentmentAnalysis.keywordsTableNegative.total',
          ),
        },
      ];

      this.indicatorsFields = [
        {
          key: 'indicator',
          label: this.$t('reports.sentmentAnalysis.indicatorTable.indicator'),
        },
        {
          key: 'value',
          label: this.$t('reports.sentmentAnalysis.indicatorTable.description'),
          sortable: true,
        },
        {
          key: 'progress',
          label: '',
        },
        {
          key: 'score',
          label: this.$t('reports.sentmentAnalysis.indicatorTable.score'),
          class: 'text-center numbers-area',
          sortable: true,
        },
        {
          key: 'total',
          label: this.$t('reports.sentmentAnalysis.indicatorTable.total'),
          class: 'text-center numbers-area',
          sortable: true,
        },
      ];

      this.indicatorLabels = [
        {
          value: null,
          text: this.$t('reports.sentmentAnalysis.selectPlaceholder'),
        },
      ];
    },
  },

  watch: {
    indicatorSelected: async function watchIndicatorSelected(value) {
      if (value) {
        this.getSentmentAnalysisByIndicators(this.dataGraph);
      } else {
        this.indicatorsItems = [];
        this.indicatorSelected = null;
      }
    },

    '$i18n.locale': function watchLocale() {
      this.changeLabels();
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.changeLabels();
    await this.getReportsData(this.dataGraph);

    EventBus.$on('update-indicator-sentiment', (items) => {
      this.getReportsData(items);
    });
  },
};
</script>

<style scoped lang="scss">
.loader {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reports-wrapper {
  width: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: row;
  justify-content: space-between;
}

.card {
  background-color: #fff;
  padding: 16px;
  border-color: #fff;

  h1 {
    font-size: 12px;
  }

  .sentiment-area {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}

.page-spacing {
  padding-left: 15px;
  padding-right: 15px;
}

.graphic-card {
  display: flex;
  flex-direction: column;
  padding: 15px 35px;
  border: 1px solid #eee;
  height: 100%;
}

.chart-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.text-color {
  color: #5f6368;
  font-size: 18px;
  fill: #5f6368;
}

.highcharts-background-pie {
  width: 0;
}

.numbers-area {
  max-width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/sentment-analysis/panels/indicator-sentiment.vue